module.exports = __webpack_public_path__ + "img/single.8d8b2881.svg";